module.exports = __webpack_public_path__ + "media/packs/images/map-e4480c8f14a9d7edd944cafe36ef20f2.svg";